import { createContext } from 'react'

const SeedTypeManagementContext = createContext();
export default SeedTypeManagementContext;